import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetBranchReportReqData } from "./GetBranchReportReqData";
import { GetBranchReportResData } from "./GetBranchReportResData";

const ENDPOINT = "/cash_flow/branch_report";

export class GetBranchReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetBranchReportReqData = null;

    constructor(params: GetBranchReportReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetBranchReportResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetBranchReportResData(res);
    }
}
